import * as React from 'react';
import AdminMenuTile from "./AdminMenuTile";
import {AdminMenuRoutes} from "../../../navigation/route/AdminMenuRoutes";
import {RouteComponentProps, withRouter} from "react-router-dom";
import './adminMenuPage.scss';
import {RootState} from "../../../store/reducer/root/RootState";
import {connect} from "react-redux";
import User from "../../../model/user/User";
import {DropDownRouteData} from "../../../navigation/route/HeaderRoutes";
import {Icon} from "../../../hiberUiKit/src/atoms/Icon/Icon";


interface ReduxProps {
	/**
	 * Logged in user.
	 */
	user: User
}

type Props = RouteComponentProps<{}> & ReduxProps;

class AdminMenuPage extends React.Component<Props> {
	render() {
		const {platformSettings, jobSettings, assetSettings} = AdminMenuRoutes;
		const platformSettingsFilteredItems = this.filterItems(platformSettings);
		const jobSettingsFilteredItems = this.filterItems(jobSettings);
		const assetSettingsFilteredItems = this.filterItems(assetSettings);
		return (
			<div className="menu-container">
				{platformSettingsFilteredItems.length > 0 &&
					<AdminMenuTile
						menuIcon={Icon.SettingsEmpty}
						categoryName="Platform settings"
						menuItems={platformSettingsFilteredItems}
						onItemClick={this.goToPage}/>
				}
				{jobSettingsFilteredItems.length > 0 &&
					<AdminMenuTile
						menuIcon={Icon.Job}
						categoryName="Job settings"
						menuItems={jobSettingsFilteredItems}
						onItemClick={this.goToPage}/>
				}
				{assetSettingsFilteredItems.length > 0 &&
					<AdminMenuTile
						menuIcon={Icon.SpannerEmpty}
						categoryName="Asset settings"
						menuItems={assetSettingsFilteredItems}
						onItemClick={this.goToPage}/>
				}
			</div>
		);
	}

	goToPage = (url: string) => {
		this.props.history.push(url)
	};

	filterItems = (menuItems: DropDownRouteData[]) => {
		return menuItems.filter(item => this.props.user.hasPermissions(item.allowedPermissions));
	};
}

function mapStateToProps(state: RootState) {
	return {
		user: state.user.user.get
	}
}

export default withRouter(connect<ReduxProps>(mapStateToProps)(AdminMenuPage));
